import type { Movie } from "@/mocks/movies";
import { getRecommendations } from "@/utils/movies";
import MovieCard from "@/components/base/MovieCard";
import SectionHeader from "@/components/base/SectionHeader";

interface RecommendationsProps {
  movie: Movie;
  all: Movie[];
}

export default function Recommendations({ movie, all }: RecommendationsProps) {
  const list = getRecommendations(movie, all, 6);
  if (list.length === 0) return null;

  return (
    <section>
      <SectionHeader title="相关推荐" subtitle="根据类型与主演为你推荐" />
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-5">
        {list.map((item, index) => (
          <MovieCard key={item.id} movie={item} index={index} />
        ))}
      </div>
    </section>
  );
}